// extracted by mini-css-extract-plugin
export default {"match":"liga_match__SqUFy","fixture":"liga_fixture__bzAUv","round":"liga_round__hN7Ew"};